/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import ProfileTop from "./ProfileTop";
import ProfileControls from "./ProfileControls";
import useResponsive from "../../hooks/useResponsive";
import { Link, useNavigate } from "react-router-dom";
import { PATH_AUTH } from "../../routes/path";
import { FacilityDataPropsType } from "../../interface/users";
import { useAuth } from "../../hooks/useAuth";

const isFacilitySetupIncomplete = (facilityInfo: FacilityDataPropsType) =>
  !facilityInfo?.reg_no ||
  !facilityInfo?.address ||
  !facilityInfo?.city ||
  !facilityInfo?.state ||
  !facilityInfo?.phone_number ||
  !facilityInfo?.contact_name ||
  !facilityInfo?.contact_email ||
  !facilityInfo?.contact_job_title ||
  !facilityInfo?.specialties ||
  !facilityInfo?.locationDetails?.address;

const ProfileContent = ({
  facility_info,
  loading,
}: {
  facility_info: FacilityDataPropsType;
  loading: boolean;
}) => {
  const isMedium = useResponsive("down", "md", "xs");
  const isSmall = useResponsive("down", "sm", "xl");
  const navigate = useNavigate();
  const { user } = useAuth();
  const setupIncomplete = isFacilitySetupIncomplete(facility_info);

  const hanleVerification = () => {
    navigate(PATH_AUTH.verification, {
      state: {
        ...user,
        ...facility_info,
        _id: facility_info?._id ?? user?._id,
        facility_size: facility_info?.facility_size,
        mode: setupIncomplete ? "complete-setup" : "verification",
      },
    });
  };

  return (
    <Box
      sx={{
        padding: isMedium ? 3 : 4,
      }}
    >
      {!loading && !!facility_info && (
        <ProfileTop facility_info={facility_info} />
      )}
      {(setupIncomplete || facility_info?.verification !== "vetted") && (
        <Stack sx={{ my: 3 }} direction={"row"}>
          <Button onClick={hanleVerification} variant="contained">
            {setupIncomplete ? "Complete Setup" : "Verification Process"}
          </Button>
        </Stack>
      )}
      <ProfileControls />
    </Box>
  );
};

export default ProfileContent;
